import type { IAddress } from "../vue-interfaces/i-address";
import type { IPhoneNumber } from "../vue-interfaces/i-phone-number";
import { ApplicationEnum } from "../../enums/enums";

export class EmergencyContact {
    public id: string;
    public patientId?: string; // is used for update endpoint.
    public referralId?: string; // is used for update endpoint.4
    public agencyId?: string;
    public accountId?: string;
    public application?: ApplicationEnum;
    public firstName: string = "";
    public mi: string = "";
    public lastName: string = "";
    public email: string = "";
    public isPrimary: boolean = false;
    public isUsingPrimaryAddress: boolean = false;
    public address: IAddress = {
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        zipCode: "",
        county: "",
        country: ""
    };
    public relationship: number = null;
    public phoneNumbers: IPhoneNumber[] = [
        {
            number: "",
            extension: "",
            type: 0,
            isPrimary: true,
            country: null,
            ordinal: 1
        },
        {
            number: "",
            extension: "",
            type: 0,
            isPrimary: false,
            country: null,
            ordinal: 2
        }
    ];
    public contactOrder: number = null;

    public constructor(data?: EmergencyContact) {
        if (data) {
            Object.assign(this, data);
        }
    }
}
